module.exports = __webpack_public_path__ + "static/img/wealth_level_87.6b28c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_87.png
// module id = FHQV
// module chunks = 0